import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum VariantExchangeGuidanceLevel {
  COLLECTION = "collection",
  TAG = "tag",
  TEAM = "team",
  PRODUCT = "product",
}

export const VariantExchangeGuidanceSchema = z.object({
  guidanceLevel: createEnum(VariantExchangeGuidanceLevel, {
    enumName: "VariantExchangeGuidanceLevel",
  }),
  guidanceLevelId: z.string(),
  guidance: z.string(),
  enabled: z.boolean(),
});
export type VariantExchangeGuidance = z.infer<
  typeof VariantExchangeGuidanceSchema
>;

export function areVariantExchangeGuidanceIdentifiersEqual(
  a: VariantExchangeGuidance,
  b: VariantExchangeGuidance,
): boolean {
  return (
    a.guidanceLevel === b.guidanceLevel &&
    a.guidanceLevelId === b.guidanceLevelId
  );
}

export function areVariantExchangeGuidanceEqual(
  a: VariantExchangeGuidance,
  b: VariantExchangeGuidance,
): boolean {
  return (
    areVariantExchangeGuidanceIdentifiersEqual(a, b) &&
    a.enabled === b.enabled &&
    a.guidance.trim() === b.guidance.trim()
  );
}
